import React from 'react';
import Icon from '../../../components/AppIcon';


const ContactHero = ({ currentLanguage, translations }) => {
  return (
    <section className="relative bg-gradient-to-br from-slate-900 via-blue-900 to-blue-800 text-white overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-32 h-32 border border-white/20 rounded-full"></div>
        <div className="absolute top-40 right-32 w-24 h-24 border border-white/20 rounded-full"></div>
        <div className="absolute bottom-32 left-1/3 w-16 h-16 border border-white/20 rounded-full"></div>
      </div>
      <div className="relative max-w-7xl mx-auto px-6 py-20 lg:py-32">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center backdrop-blur-sm">
                  <Icon name="MessageCircle" size={24} />
                </div>
                <span className="text-blue-200 font-medium">{translations?.hero?.badge}</span>
              </div>
              
              <h1 className="text-4xl lg:text-6xl font-bold leading-tight">
                {translations?.hero?.title}
              </h1>
              
              <p className="text-xl text-blue-100 leading-relaxed max-w-2xl">
                {translations?.hero?.description}
              </p>
            </div>

            {/* Quick Stats */}
            <div className="grid grid-cols-3 gap-6">
              <div className="text-center">
                <div className="text-2xl font-bold text-white">24h</div>
                <div className="text-sm text-blue-200">{translations?.hero?.stats?.response}</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-white">5</div>
                <div className="text-sm text-blue-200">{translations?.hero?.stats?.languages}</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-white">€0.8M+</div>
                <div className="text-sm text-blue-200">{translations?.hero?.stats?.invested}</div>
              </div>
            </div>
          </div>

          {/* Contact Cards Preview */}
          <div className="relative">
            <div className="grid gap-4">
              {/* Partnership Card */}
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                    <Icon name="Handshake" size={24} className="text-white" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-white">{translations?.hero?.cards?.partnership?.title}</h3>
                    <p className="text-blue-200 text-sm">{translations?.hero?.cards?.partnership?.subtitle}</p>
                  </div>
                </div>
              </div>

              {/* Investment Card */}
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center">
                    <Icon name="TrendingUp" size={24} className="text-white" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-white">{translations?.hero?.cards?.investment?.title}</h3>
                    <p className="text-blue-200 text-sm">{translations?.hero?.cards?.investment?.subtitle}</p>
                  </div>
                </div>
              </div>

              {/* General Inquiry Card */}
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-purple-500 rounded-full flex items-center justify-center">
                    <Icon name="MessageSquare" size={24} className="text-white" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-white">{translations?.hero?.cards?.general?.title}</h3>
                    <p className="text-blue-200 text-sm">{translations?.hero?.cards?.general?.subtitle}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;